export default __webpack_public_path__ + "static/media/c(5).405a26d1.jpg";